   
                        
  
                                                  
                          
   

import { nullFunction } from "../util/utilities";
import Utilities from "../util/utilities";
import { isIOS } from "../util/environment";
import Application from "../app";

const TaskQueue = {
  pending: false,
  tasks: [],
  handler: null,
  nextTick: function (callback, target, app) {
    const handler = this.getHandler();

    let _resolve;
    this.tasks.push(() => {
      if (callback) {
        callback.call(target);
      }

      if (_resolve) {
        _resolve(target);
      }
    });

    if (!this.pending) {
      this.pending = true;

      if (app) {
        app.hook('beforeUpdate');
      }

      handler();
    }

    if (!callback && typeof Promise !== 'undefined') {
      return Application.Promise(resolve => {
        _resolve = resolve;
      });
    }
  },
  execute: function () {
    TaskQueue.pending = false;
    const tasks = TaskQueue.tasks.slice(0);
    TaskQueue.tasks.length = 0;

    tasks.forEach(task => task());
  },
     
                                                                              
     
  getHandler: function () {
    if (typeof this.handler !== 'function') {
                                                                                   
                                                            
                                                                              
                                                                             
                                                                               
                                              
                              
      if (typeof Promise !== 'undefined' && Utilities.isNative(Promise)) {
        const p = Promise.resolve();
        this.handler = () => {
          p.then(this.execute).catch(err => console.error(err));

                                                                                  
                                                                                  
                                                                                 
                                                                               
                                                                                
          if (isIOS) {
            setTimeout(nullFunction);
          }
        };
      } else if (typeof MutationObserver !== 'undefined' && (
          Utilities.isNative(MutationObserver) ||
                                  
          MutationObserver.toString() === '[object MutationObserverConstructor]'
        )) {
                                                                      
                                                 
        let counter = 1;
        const observer = new MutationObserver(this.execute);
        const textNode = document.createTextNode(String(counter));
        observer.observe(textNode, {
          characterData: true
        });
        this.handler = () => {
          counter = (counter + 1) % 2;
          textNode.data = String(counter)
        }
      } else {
                                 
                                  
        this.handler = () => {
          setTimeout(this.execute, 0);
        }
      }
    }

    return this.handler;
  }
};

export default TaskQueue;



// WEBPACK FOOTER //
// ./src/observer/queue.js